import axios from "axios";

// The member screen's Profile menu and Membership fee section (slice 2):
// reading and paying the membership fee, activating a member, resetting a
// member's password and disabling/enabling a member. These are customer
// journey routes: errors carry their details under `data`. Every action
// commits and returns the whole envelope.
export default {
    namespaced: true,

    state: {
        fee: null,
    },

    getters: {
        fee(state) {
            return state.fee;
        },
    },

    mutations: {
        SET_FEE(state, fee) {
            return (state.fee = fee);
        },
    },

    actions: {
        // GET /customers/{id}/membership-fee
        async fetchMembershipFee({ commit }, customerId) {
            return await axios
                .get(`/api/v1/customers/${customerId}/membership-fee`)
                .then((res) => {
                    commit("SET_FEE", res.data);
                    return res.data;
                })
                .catch((err) => {
                    return Promise.reject(err);
                });
        },

        // POST /customers/{id}/activate: the refreshed fee payload, 422 under
        // data.fee when the fee is not fully paid, 409 when already active
        async activateMember({ commit }, customerId) {
            return await axios
                .post(`/api/v1/customers/${customerId}/activate`)
                .then((res) => {
                    commit("SET_FEE", res.data);
                    return res.data;
                })
                .catch((err) => {
                    return Promise.reject(err);
                });
        },

        // POST /customers/{id}/password {password, password_confirmation}
        async changeMemberPassword({ commit }, { customerId, password, password_confirmation }) {
            return await axios
                .post(`/api/v1/customers/${customerId}/password`, { password, password_confirmation })
                .then((res) => res.data)
                .catch((err) => {
                    return Promise.reject(err);
                });
        },

        // PATCH /customers/{id}/status {action: 'disable'|'enable', reason}
        async changeMemberStatus({ commit }, { customerId, action, reason }) {
            return await axios
                .patch(`/api/v1/customers/${customerId}/status`, { action, reason })
                .then((res) => res.data)
                .catch((err) => {
                    return Promise.reject(err);
                });
        },
    },
};
